import initialState from './initialState'
import {
    INITIALIZE_APP,
    SET_LANGUAGE,
    SET_USER_ID,
    SET_SESSION_DATA,
    TOGGLE_APP_STATE
} from '../constants/actionTypes'


export default (state = initialState, action) => {
    switch (action.type) {
        case INITIALIZE_APP:
            return {
                ...state,
                userId: action.userId,
                clientIp: action.clientIp,
                countryCode: action.countryCode,
            }

        case SET_LANGUAGE:
            return {
                ...state,
                language: action.language
            }

        case SET_USER_ID:
            return {
                ...state,
                userId: action.userId
            }

        case SET_SESSION_DATA:
            return {
                ...state,
                session: {
                    ...action.session
                }
            }

        case TOGGLE_APP_STATE:
            return {
                ...state,
                isOpen: action.isOpen

            }

        default:
            return state
    }
}
